import axios from "../../../../api/axios";

export type GinoCreditsData = {
  charged: number;
  used: number;
  balance: number;
};

type GinoCreditsResponse = {
  data: GinoCreditsData;
  message: string;
};

type TokenRequest = {
  message: string;
  assistantId: string;
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;
};

export const getGinoCredits = async (): Promise<GinoCreditsResponse["data"]> => {
  const response = await axios.get("/subscriptions/tokens/summary");
  return response.data.data;
};

export const updateGinoTokens = async (tokenRequest: TokenRequest) => {
  const response = await axios.post("/gino-tokens/use", tokenRequest);
  return response.data;
};
